<template>
  <el-container style="min-height:100vh;">
    <el-header style="background:#409eff;color:#fff;display:flex;justify-content:space-between;">
      <span>客服工作台</span>
      <el-button type="text" style="color:#fff;" @click="logout">退出</el-button>
    </el-header>
    <el-main><router-view /></el-main>
  </el-container>
</template>

<script>
import { clearToken } from '../utils/auth';
export default {
  methods: {
    logout() {
      clearToken();
      this.$router.replace('/login');
    }
  }
};
</script>

